<template>
  <div class="customer-management">
    <div>
      <div class="header">
        <h2>客服管理</h2>
        <div class="header-right">
          <el-input placeholder="搜索客服名称或ID..." @change="changeValue()" prefix-icon="el-icon-search"
            v-model="searchForm.keyWord" class="search-input"></el-input>
          <el-button type="primary" icon="el-icon-plus" @click="addCustomerService">新增客服</el-button>
        </div>
      </div>

      <div class="filter-section">
        <div class="filter-left">
          <!-- <div class="filter-item">
                <span>权限等级：</span>
                <el-select v-model="roleLevel" placeholder="全部" size="small">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="管理员" value="admin"></el-option>
                  <el-option label="高级客服" value="seniorService"></el-option>
                  <el-option label="普通客服" value="normalService"></el-option>
                </el-select>
              </div> -->
          <div class="filter-item">
            <span>在线状态：</span>
            <el-select v-model="searchForm.status" placeholder="全部" size="small" @change="changeState">
              <el-option label="全部" value=""></el-option>
              <el-option label="在线" value="1"></el-option>
              <el-option label="离线" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-right">
          <el-button icon="el-icon-download" size="small" @click="importData">导出数据</el-button>
          <el-button icon="el-icon-s-operation" size="small" @click="batchOperation">批量操作</el-button>
        </div>
      </div>

      <el-table :data="filteredTableData" border style="width: 100%" size="small">
        <el-table-column label="客服信息" align="center" width="350px">
          <template slot-scope="scope">
            <div class="customer-info">
              <el-avatar :size="40" :src="scope.row.avatar"></el-avatar>
              <div class="customer-details">
                <div class="customer-name">{{ scope.row.realname }}</div>
                <div class="customer-id">ID: {{ scope.row.customerServiceNumber }}</div>
              </div>
            </div>
          </template>
        </el-table-column>


        <!-- <el-table-column label="权限等级" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="getRoleTagType(scope.row.role)" size="small">{{ scope.row.role }}</el-tag>
              </template>
            </el-table-column> -->

        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <div class="status-indicator">
              <span class="status-dot"
                :class="{ 'offline': scope.row.status == 0, 'online': scope.row.status == 1 }"></span>
              {{ scope.row.status == 0 ? '离线' : '在线' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最近登录" align="center">
          <template slot-scope="scope">
            {{ scope.row.loginTime }}
          </template>
        </el-table-column>

        <el-table-column label="会话统计" min-width="180" align="center">
          <template slot-scope="scope">
            <div>
              今日: {{ scope.row.todayConversationNumber }} 会话
              <!-- <div class="session-duration">平均响应: {{ scope.row.avgResponse }}</div> -->
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="140" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" class="delete-button" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <div class="pagination-info">显示 {{ query.pageNum }} 到 {{ query.pageSize }} 条，共 {{ total }} 条记录</div>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="query.pageNum"
          :page-size="query.pageSize" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <!-- 新增客服弹窗 -->
      <!-- <el-dialog title="新增客服" :visible.sync="addDialogVisible" width="40%" :before-close="handleClose">
            <el-form ref="addForm" :model="AddServicePeopleForm">
              <el-form-item label="客服名称">
                <el-input v-model="AddServicePeopleForm.name" placeholder="请输入客服名称"></el-input>
              </el-form-item>
          </el-dialog> -->
      <el-dialog title="新增客服" :visible.sync="addDialogVisible" width="30%" :before-close="handleClose">
        <el-form ref="form" :model="AddServicePeopleForm" label-width="80px">
          <el-form-item label="用户名">
            <el-input v-model="AddServicePeopleForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input :disabled="userId ? true : false" v-model="AddServicePeopleForm.userPhone"></el-input>
          </el-form-item>
          <!-- <el-form-item label="详细地址">
            <el-input v-model="AddServicePeopleForm.address"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="AddServicePeople">确 定</el-button>
        </span>

      </el-dialog>
    </div>


  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { selectUserList, saveOrUpdateUser, deleteUser } from '@/api/sjzx'
export default {
  name: 'CustomerManagement',
  data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 10
      },
      searchForm: {
        status: '',
        keyWord: ''
      },
      total: 0,
      userId: '',//没有值代表新增，有值代表编辑
      addDialogVisible: false,
      AddServicePeopleForm: {
        // address: '',
        userName: '',
        userPhone: '',
        // userId: ''
      },
      searchText: '',
      roleLevel: '',
      onlineStatus: '',
      currentPage: 1,
      pageSize: 5,
      totalRecords: 12,
      tableData: [
      ]
    }
  },
  created() {
    // this.getIsHave()
  },
  computed: {
    ...mapGetters([
      "identityObj",
    ]),
    filteredTableData() {
      let result = [...this.tableData]

      if (this.searchText) {
        const searchLower = this.searchText.toLowerCase()
        result = result.filter(item =>
          item.name.toLowerCase().includes(searchLower) ||
          item.id.toLowerCase().includes(searchLower)
        )
      }

      if (this.roleLevel) {
        const roleMap = {
          'admin': '管理员',
          'seniorService': '高级客服',
          'normalService': '普通客服'
        }
        result = result.filter(item => item.role === roleMap[this.roleLevel])
      }

      if (this.onlineStatus) {
        const statusMap = {
          'online': '在线',
          'offline': '离线'
        }
        result = result.filter(item => item.status === statusMap[this.onlineStatus])
      }

      return result
    }
  },

  mounted() {
    this.getSelectUserList()
  },
  methods: {
    //判断是草稿还是保存
    //   getIsHave() {
    //   //0保存，1草稿

    //   // let identityObj = localStorage.getItem("identityObj") || []
    //   // 从本地存储加载草稿
    //   const draft = localStorage.getItem('identityObj')
    //   if (draft) {
    //     try {
    //       const identityObj = JSON.parse(draft)
    //       if (identityObj) {
    //         // let obj = JSON.parse(identityObj)
    //         this.IsHaveobj = identityObj.content.shop.draftFlag == null ? false : identityObj.content.shop.draftFlag == 0 ? true : false
    //         console.log(this.IsHave,'查看this.IsHave')
    //       }
    //     } catch (e) {
    //       console.error('解析草稿数据失败', e)
    //     }
    //   }

    // },
    open() {
      //跳转注册页面路由
      this.$router.push({ name: "supplierRegistration" });
    },
    changeState() {
      this.getSelectUserList()
    },
    changeValue() {
      this.getSelectUserList()
    },
    getRoleTagType(role) {
      const typeMap = {
        '管理员': 'danger',
        '高级客服': 'warning',
        '普通客服': 'success'
      }
      return typeMap[role] || 'info'
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleClose() {
      //关闭新增弹窗
      this.addDialogVisible = false
      this.AddServicePeopleForm = {
        // address: '',
        userName: '',
        userPhone: '',
      }
    },
    async handleEdit(row) {
      this.userId = row.userId
      this.addDialogVisible = true
      let { realname, phone } = row;
      this.AddServicePeopleForm = {
        // address: address,
        userName: realname,
        userPhone: phone,
      };
    },

    handleDelete(row) {
      this.$confirm('确定要删除该客服吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          id: row.userId
        }
        let res = await deleteUser(params)
        if (res.code == 0) {
          this.$message.success(` ${res.msg}`)
          this.getSelectUserList()
        } else {
          this.$message.error(` ${res.msg}`)
        }

      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    addCustomerService() {
      // this.$message.info('新增客服')
      // 新增客服
      this.addDialogVisible = true
      this.userId = ''
    },

    async AddServicePeople() {
      //添加客服人员
      let formData = { ...this.AddServicePeopleForm };
      if (this.userId) {
        formData.userId = this.userId;
      }
      console.log(formData);
      let res = await saveOrUpdateUser(formData);
      if (res.code === 0) {
        this.$message.success('添加成功');
        this.handleClose();
        this.getSelectUserList();

      } else {
        this.$message.error('添加失败');
      }

    },
    importData() {
      this.$message.info('导出数据')
    },
    batchOperation() {
      this.$message.info('批量操作')
    },
    //数据层
    async getSelectUserList() {
      let params = {
        ...this.query,
        ...this.searchForm
      }
      let res = await selectUserList(params)
      if (res.code == 0) {
        res.data.records.forEach(item => {
          item.avatar = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
        })
        this.tableData = res.data.records || []
        this.total = Number(res.data.total)
      }

    },
  }
}
</script>

<style lang="less" scoped>
.customer-management {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }

    .header-right {
      display: flex;
      align-items: center;

      .search-input {
        width: 240px;
        margin-right: 15px;
      }
    }
  }

  .filter-section {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;

    .filter-left {
      display: flex;
    }

    .filter-right {
      display: flex;
      gap: 10px;
    }

    .filter-item {
      display: flex;
      align-items: center;
      margin-right: 30px;

      span {
        margin-right: 8px;
        white-space: nowrap;
      }

      .el-select {
        width: 120px;
      }
    }
  }

  .customer-info {
    display: flex;
    align-items: center;

    .customer-details {
      margin-left: 10px;

      .customer-name {
        font-weight: 500;
      }

      .customer-id {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  .status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;

    .status-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 5px;

      &.online {
        background-color: #67c23a;
      }

      &.offline {
        background-color: #909399;
      }
    }
  }

  .session-duration {
    font-size: 12px;
    color: #606266;
    margin-top: 4px;
  }

  .delete-button {
    color: #f56c6c;
  }

  .pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .pagination-info {
      color: #606266;
      font-size: 14px;
    }
  }
}

.white-bg {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
}
</style>
